/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreModule } from '@dm/core';

import { SmartAssistantGifContainerModule } from '../gif-container/gif-container.module';
import { GuidanceStepsModule } from './guidance-steps/guidance-steps.module';
import { StorageResourcesGuidanceComponent } from './storage-resources-guidance.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        RouterModule,
        FormsModule,
        GuidanceStepsModule,
        SmartAssistantGifContainerModule,
    ],
    declarations: [StorageResourcesGuidanceComponent],
    exports: [StorageResourcesGuidanceComponent],
})
export class StorageResourcesGuidanceModule { }
